import { agentApiPath } from "constants/defaultValues";
import { put, takeEvery } from "redux-saga/effects";
import { bearerRequest } from "services/requests.services";
import { ADD_ADVOCATE_FAILED, ADD_ADVOCATE_SUCCESS, DOWNLOAD_CONTRACT_FAILED, DOWNLOAD_CONTRACT_SUCCESS, GET_ADVOCATES_LIST, GET_ADVOCATES_LIST_FAILED, GET_ADVOCATES_LIST_SUCCESS, SEND_CONTRACT_FAILED, SEND_CONTRACT_SUCCESS, UPDATE_ADVOCATE_FAILED, UPDATE_ADVOCATE_STATUS_FAILED, UPDATE_ADVOCATE_STATUS_SUCCESS, UPDATE_ADVOCATE_SUCCESS, UPLOAD_ADVOCATE_DOC_FAILED, UPLOAD_ADVOCATE_DOC_SUCCESS, VIEW_CONTRACT_FAILED, VIEW_CONTRACT_SUCCESS } from "./actions";
function* getAdvocatesData(action) {
  try {
    const searchParam = action.state.searchKeyword ? encodeURIComponent(action.state.searchKeyword) : "";

    const data = yield bearerRequest("GET", `${agentApiPath}/get/Advocate?page=${action.state.page}&searchKeyword=${searchParam}`);
    if (data?.response?.status === 401) {
      yield put({
        type: GET_ADVOCATES_LIST_FAILED,
        message: data?.response?.data?.message || "Please login again..."
      });

      return;
    }
    if (data?.success === false) {
      yield put({
        type: GET_ADVOCATES_LIST_FAILED,
        message: data?.message || "Failed to get data!"
      });

      return;
    }

    yield put({ type: GET_ADVOCATES_LIST_SUCCESS, data: data || [] });
  } catch (error) {
    yield put({
      type: GET_ADVOCATES_LIST_FAILED,
      message: error?.response?.data?.message || error?.message || "Failed to get data!"
    });
  }
}
function* addAdvocate(action) {
  try {
    const payload = action.state.isMultipart ? action.state.formData : action.state;
    const searchParam = action.state.searchKeyword ? action.state.searchKeyword : "";
    const data = yield bearerRequest("POST", `${agentApiPath}/create/Advocate`, payload);
    if (data?.response?.status === 401) {
      const msg = data?.response?.data?.message === "Not authorised" ? "Please login again..." : data?.msg || data?.response?.data?.message || "Failed to add Advocate!";
      yield put({
        type: ADD_ADVOCATE_FAILED,
        message: msg
      });

      return;
    }
    if (data?.success === false) {
      yield put({
        type: ADD_ADVOCATE_FAILED,
        message: data?.message || data?.msg || "Failed to add Advocate!"
      });

      return;
    }
    yield put({ type: ADD_ADVOCATE_SUCCESS, data: data.data, message: data?.msg });
    yield put({ type: GET_ADVOCATES_LIST, state: { page: action?.currentPage || 1, searchKeyword: searchParam } });
  } catch (error) {
    yield put({
      type: ADD_ADVOCATE_FAILED,
      message: error?.response?.data?.message || error?.message || error?.msg || "Failed to add Advocate!"
    });
  }
}

function* updateAdvocate(action) {
  try {
    const id = action.state._id;
    const payload = action.state.data;
    const searchParam = action.state.searchKeyword ? action.state.searchKeyword : "";
    const data = yield bearerRequest("PUT", `${agentApiPath}/update/Advocate/${id}`, payload);
    if (data?.response?.status === 401) {
      const msg = data?.response?.data?.message === "Not authorised" ? "Please login again..." : data?.msg || data?.response?.data?.message || "Failed to update Advocate!";
      yield put({
        type: UPDATE_ADVOCATE_FAILED,
        message: msg
      });

      return;
    }
    if (data?.success === false) {
      yield put({
        type: UPDATE_ADVOCATE_FAILED,
        message: data?.message || data?.msg || "Failed to update Advocate!"
      });

      return;
    }
    yield put({ type: UPDATE_ADVOCATE_SUCCESS, data: data.data, message: data?.msg });
    yield put({ type: GET_ADVOCATES_LIST, state: { page: action?.currentPage || 1, searchKeyword: searchParam } });
  } catch (error) {
    yield put({
      type: UPDATE_ADVOCATE_FAILED,
      message: error?.response?.data?.message || error?.message || error?.msg || "Failed to update Advocate!"
    });
  }
}

function* updateAdvocateStatus(action) {
  try {
    const id = action.state.id;
    const payload = { status: action.state.status };
    const searchParam = action.state.searchKeyword ? action.state.searchKeyword : "";
    const data = yield bearerRequest("PUT", `${agentApiPath}/update/status/${id}`, payload);
    yield put({ type: UPDATE_ADVOCATE_STATUS_SUCCESS, data: data.data, message: data.msg });
    yield put({ type: GET_ADVOCATES_LIST, state: { page: action?.currentPage || 1, searchKeyword: searchParam } });
  } catch (error) {
    yield put({
      type: UPDATE_ADVOCATE_STATUS_FAILED,
      message: error?.response?.data?.message || error?.message || error?.msg || "Failed to update Status!"
    });
  }
}
function* uploadAdvocateDoc(action) {
  try {
    const payload = action.state.formData;
    const id = action.state.id;
    const searchParam = action.state.searchKeyword ? action.state.searchKeyword : "";
    const response = yield bearerRequest("POST", `${agentApiPath}/upload/AdvocateDocs/${id}`, payload);
    if (response instanceof Error || response?.response?.status >= 400) {
      throw response;
    }

    yield put({
      type: UPLOAD_ADVOCATE_DOC_SUCCESS,
      data: response?.data,
      message: response?.message || "Document Uploaded Successfully!"
    });
    yield put({ type: GET_ADVOCATES_LIST, state: { page: action?.currentPage || 1, searchKeyword: searchParam } });
  } catch (error) {
    yield put({
      type: UPLOAD_ADVOCATE_DOC_FAILED,
      message: error?.response?.data?.message || error?.message || error?.msg || "Failed to upload document!"
    });
  }
}
function* viewContract(action) {
  try {
    const response = yield bearerRequest("GET", `${agentApiPath}/get/Advocate/${action.state.id}`);
    if (response instanceof Error || response?.response?.status >= 400) {
      throw response;
    }
    yield put({
      type: VIEW_CONTRACT_SUCCESS,
      data: response?.data,
      message: response?.data?.msg || "Contract Open Successfully!"
    });
    yield put({ type: GET_ADVOCATES_LIST, state: { page: action?.currentPage || 1, searchKeyword: action.state.searchKeyword || "" } });
  } catch (error) {
    yield put({
      type: VIEW_CONTRACT_FAILED,
      message: error?.response?.data?.message || error?.message || error?.msg || "Failed to view contract!"
    });
  }
}
function* sendContract(action) {
  try {
    const response = yield bearerRequest("POST", `${agentApiPath}/sendContract/${action.state.id}`);
    if (response instanceof Error || response?.response?.status >= 400) {
      throw response;
    }

    yield put({
      type: SEND_CONTRACT_SUCCESS,
      data: response?.data,
      message: response?.data?.msg || "Contract Sent Successfully!"
    });
  } catch (error) {
    const errorMessage = error?.response?.data?.message || error?.response?.data?.msg || error?.data?.message || error?.data?.msg || error?.msg || error?.message || "Failed to send contract!";

    yield put({
      type: SEND_CONTRACT_FAILED,
      message: errorMessage
    });
  }
}
function* downloadContract(action) {
  try {
    const response = yield bearerRequest("GET", `${agentApiPath}/get/Advocate/${action.state.id}`);
    if (response instanceof Error || response?.response?.status >= 400) {
      throw response;
    }
    const contractLink = response?.data?.contractLink;
    if (contractLink) {
      window.open(contractLink, "_blank");
    }
    yield put({
      type: DOWNLOAD_CONTRACT_SUCCESS,
      message: "Download Contract Successfully Fetched!"
    });
  } catch (error) {
    yield put({
      type: DOWNLOAD_CONTRACT_FAILED,
      message: error?.response?.data?.message || error?.message || "Failed to download contract fetched!"
    });
  }
}
export default function* advocatesSaga() {
  yield takeEvery("GET_ADVOCATES_LIST", getAdvocatesData);
  yield takeEvery("ADD_ADVOCATE", addAdvocate);
  yield takeEvery("UPDATE_ADVOCATE", updateAdvocate);
  yield takeEvery("UPDATE_ADVOCATE_STATUS", updateAdvocateStatus);
  yield takeEvery("VIEW_CONTRACT", viewContract);
  yield takeEvery("SEND_CONTRACT", sendContract);
  yield takeEvery("UPLOAD_ADVOCATE_DOCUMENT", uploadAdvocateDoc);
  yield takeEvery("DOWNLOAD_CONTRACT", downloadContract);
}
